module.exports = __webpack_public_path__ + "static/lframe-pay-it-faster-39bcb5fcae86a2baf684fc2a2805fc01.png";